import { render, staticRenderFns } from "./AssigneesSearchPopover.vue?vue&type=template&id=6e81231a&scoped=true"
import script from "./AssigneesSearchPopover.vue?vue&type=script&lang=js"
export * from "./AssigneesSearchPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e81231a",
  null
  
)

export default component.exports